/**
 * RTL Text Patch for CreateJS Text
 * Adds RTL (Right-to-Left) text rendering support to createjs.Text
 */
export default class RTLTextPatch {
    static _rtlProvider = null;

    /**
     * Set a provider function to determine RTL mode dynamically
     * @param {Function} provider - Function that returns true if RTL mode is active
     */
    static setRTLProvider(provider) {
        RTLTextPatch._rtlProvider = provider;
    }

    /**
     * Check if a text object should use RTL mode
     * @param {Object} textObj - The text object to check
     * @returns {boolean} True if RTL mode should be used
     */
    static _shouldUseRTL(textObj) {
        if (textObj && textObj.rtl !== undefined) return !!textObj.rtl;
        const provider = RTLTextPatch._rtlProvider;
        if (typeof provider === 'function') return !!provider();
        return false;
    }

    /**
     * Apply RTL patch to createjs.Text
     */
    static apply() {
        if (typeof createjs === 'undefined' || !createjs.Text) {
            console.warn('RTLTextPatch: createjs.Text not found');
            return;
        }

        const CurrentTextCtr = createjs.Text;

        // Wrap constructor to auto-set RTL on new text objects
        const AutoRTLTextCtr = function(text, font, color) {
            
            // Call the underlying constructor in the chain
            CurrentTextCtr.call(this, text, font, color);
            if (this.rtl === undefined && RTLTextPatch._rtlProvider) {
                this.rtl = RTLTextPatch._rtlProvider();
            }
        };

        AutoRTLTextCtr.prototype = CurrentTextCtr.prototype;
        AutoRTLTextCtr.prototype.constructor = AutoRTLTextCtr;

        // Copy static properties
        for (let prop in CurrentTextCtr) {
            if (CurrentTextCtr.hasOwnProperty(prop)) {
                AutoRTLTextCtr[prop] = CurrentTextCtr[prop];
            }
        }

        createjs.Text = AutoRTLTextCtr;
        // Patch rendering methods
        const originalPrepContext = createjs.Text.prototype._prepContext;

        createjs.Text.prototype._prepContext = function(ctx) {
            const result = originalPrepContext.call(this, ctx);
            
            if (RTLTextPatch._shouldUseRTL(this)) {
                ctx.direction = 'rtl';
            }
            
            return result;
        };
    }
}